const env = (window as any)._env_;

const Settings = {
    baseUrl: env?.REACT_APP_API_URL,
    appName: env?.REACT_APP_NAME,
    phone: env?.REACT_APP_PHONE,
    email: env?.REACT_APP_EMAIL
};

export default Settings;
